import React, { useState, useEffect } from "react";
import { X, Loader2 } from "lucide-react";

/**
 * A reusable modal for getting a note before marking a transaction as successful.
 */
const SuccessNoteModal = ({ isOpen, onClose, onSubmit, title = "Mark Successful", isLoading = false, data }) => {
  const [note, setNote] = useState("");
  const [providerReference, setProviderReference] = useState("");

  // useEffect(() => {
  //   if (isOpen) {
  //     setProviderReference(initialProviderReference || "");
  //     setNote("");
  //   }
  // }, [isOpen, initialProviderReference]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (note.trim() && providerReference.trim()) {
      onSubmit({ note, providerReference });
      setNote("");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] w-full p-4 overflow-hidden">
      <div className="relative p-6 w-full max-w-md bg-white rounded-2xl shadow-2xl transition-all duration-200 transform animate-in fade-in zoom-in">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 transition-colors hover:text-gray-600"
        >
          <X size={20} />
        </button>

        {/* Modal content */}
        <div className="space-y-6">
          <div className="text-center">
            <h3 className="mb-2 font-sans text-xl font-bold text-gray-900">
              {title}
            </h3>
            <p className="font-sans text-sm text-gray-500">
              Please enter a note before marking this payout as successful.
            </p>
            
            <p className="mt-2 font-sans text-sm text-gray-500">
              Reference: <span className="font-semibold">{data?.providerReference}</span>
            </p>
            
            <p className="font-sans text-sm text-gray-500">
              Beneficiary Name: <span className="font-semibold">{data?.beneficiary?.name}</span>
            </p>
            
            <div className="flex gap-2 justify-center items-center">
             
              
              <p className="font-sans text-sm text-gray-500">
                Amount: <span className="font-semibold">{data?.currency?.symbol || ""}{data?.amount}</span>
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex flex-col">
              <label className="block mb-2 font-sans text-sm font-semibold text-gray-700">
                Provider Reference
              </label>
              <input
                type="text"
                value={providerReference}
                onChange={(e) => setProviderReference(e.target.value)}
                placeholder="Enter provider reference here..."
                required
                className="p-3 w-full font-sans text-base rounded-xl border border-gray-200 transition-all outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
              />
            </div>
            
            <div className="flex flex-col">
              <label className="block mb-2 font-sans text-sm font-semibold text-gray-700">
                Success Note
              </label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Enter success note here..."
                required
                rows={4}
                className="p-3 w-full font-sans text-base rounded-xl border border-gray-200 transition-all outline-none resize-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
              />
            </div>

            <div className="flex gap-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 px-4 py-3 font-sans font-bold text-gray-700 rounded-xl border border-gray-200 transition-colors hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isLoading || !note.trim() || !providerReference.trim()}
                className="flex-1 py-3 px-4 bg-emerald-600 text-white rounded-xl font-bold font-sans hover:bg-emerald-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center min-w-[120px]"
              >
                {isLoading ? (
                  <>
                    <Loader2 size={18} className="mr-2 animate-spin" />
                    Submitting...
                  </>
                ) : (
                  "Confirm Success"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SuccessNoteModal;
